export var PATCH_COPY_TYPE;
(function (PATCH_COPY_TYPE) {
    PATCH_COPY_TYPE["MONO"] = "mono_patch_copy";
    PATCH_COPY_TYPE["POLY"] = "poly_patch_copy";
    PATCH_COPY_TYPE["CONTEXT"] = "aptr_sb_patches_copy";
    PATCH_COPY_TYPE["WARN"] = "custom_logic_copy_warning";
})(PATCH_COPY_TYPE || (PATCH_COPY_TYPE = {}));
export var viewStates = {
    init: 'init',
    loading: 'loading',
    error: 'error',
    normal: 'normal',
};
export var PATCH_COLORS = {
    view: '#1e3850',
    dataset: '#1e3850',
    navigation: '#1e3850',
    logic: '#1e3850',
    list: '#1e3850',
    external: '#49637b',
    integration: '#1e3850',
};
export var REFRESH_PATCHWORK_REQUEST = 'app/patchworks/REFRESH_PATCHWORK_REQUEST';
export var LOAD_PATCHWORK_REQUEST = 'app/patchworks/LOAD_PATCHWORK_REQUEST';
export var LOAD_PATCHWORK_SUCCESS = 'app/patchworks/LOAD_PATCHWORK_SUCCESS';
export var LOAD_PATCHWORK_FAILURE = 'app/patchworks/LOAD_PATCHWORK_FAILURE';
export var COPY_LOGIC_GROUP_FOCAL_PATCH = 'app/patchworks/COPY_LOGIC_GROUP_FOCAL_PATCH';
export var UPDATE_PATCHWORK_REQUEST = 'app/patchworks/UPDATE_PATCHWORK_REQUEST';
export var UPDATE_PATCHWORK_SUCCESS = 'app/patchworks/UPDATE_PATCHWORK_SUCCESS';
export var UPDATE_PATCHWORK_FAILURE = 'app/patchworks/UPDATE_PATCHWORK_FAILURE';
export var UPDATE_PATCHWORK_ENTRYPOINT = 'app/patchworks/UPDATE_PATCHWORK_ENTRYPOINT';
export var UPDATE_PATCHWORK_ENTRYPOINT_SUCCESS = 'app/patchworks/UPDATE_PATCHWORK_ENTRYPOINT_SUCCESS';
export var UPDATE_PATCHWORK_ENTRYPOINT_FAIL = 'app/patchworks/UPDATE_PATCHWORK_ENTRYPOINT_FAIL';
export var CREATE_PATCH_REQUEST = 'app/patchworks/CREATE_PATCH_REQUEST';
export var CREATE_PATCH_SUCCESS = 'app/patchworks/CREATE_PATCH_SUCCESS';
export var CREATE_PATCH_FAILURE = 'app/patchworks/CREATE_PATCH_FAILURE';
export var UPDATE_PATCH_REQUEST = 'app/patchworks/UPDATE_PATCH_REQUEST';
export var UPDATE_PATCH_SUCCESS = 'app/patchworks/UPDATE_PATCH_SUCCESS';
export var UPDATE_PATCH_FAILURE = 'app/patchworks/UPDATE_PATCH_FAILURE';
export var CREATE_EDGE_REQUEST = 'app/patchworks/CREATE_EDGE_REQUEST';
export var CREATE_EDGE_SUCCESS = 'app/patchworks/CREATE_EDGE_SUCCESS';
export var CREATE_EDGE_FAILURE = 'app/patchworks/CREATE_EDGE_FAILURE';
export var UPDATE_EDGE_REQUEST = 'app/patchworks/UPDATE_EDGE_REQUEST';
export var UPDATE_EDGE_SUCCESS = 'app/patchworks/UPDATE_EDGE_SUCCESS';
export var UPDATE_EDGE_FAILURE = 'app/patchworks/UPDATE_EDGE_FAILURE';
export var LOAD_VIEW_REQUEST = 'app/patchworks/LOAD_VIEW_REQUEST';
export var LOAD_VIEW_SUCCESS = 'app/patchworks/LOAD_VIEW_SUCCESS';
export var LOAD_VIEW_FAILURE = 'app/patchworks/LOAD_VIEW_FAILURE';
export var LOAD_DATASET_REQUEST = 'app/patchworks/LOAD_DATASET_REQUEST';
export var LOAD_DATASET_SUCCESS = 'app/patchworks/LOAD_DATASET_SUCCESS';
export var LOAD_DATASET_FAILURE = 'app/patchworks/LOAD_DATASET_FAILURE';
export var DELETE_PATCH_REQUEST = 'app/patchworks/DELETE_PATCH_REQUEST';
export var DELETE_PATCH_SUCCESS = 'app/patchworks/DELETE_PATCH_SUCCESS';
export var DELETE_PATCH_FAILURE = 'app/patchworks/DELETE_PATCH_FAILURE';
export var BULK_DELETE_PATCHES_REQUEST = 'app/patchworks/BULK_DELETE_PATCHES_REQUEST';
export var BULK_DELETE_PATCHES_SUCCESS = 'app/patchworks/BULK_DELETE_PATCHES_SUCCESS';
export var BULK_DELETE_PATCHES_FAILURE = 'app/patchworks/BULK_DELETE_PATCHES_FAILURE';
export var DELETE_EDGE_REQUEST = 'app/patchworks/DELETE_EDGE_REQUEST';
export var DELETE_EDGE_SUCCESS = 'app/patchworks/DELETE_EDGE_SUCCESS';
export var DELETE_EDGE_FAILURE = 'app/patchworks/DELETE_EDGE_FAILURE';
export var LOAD_GROUPS_REQUEST = 'app/patchworks/LOAD_GROUPS_REQUEST';
export var LOAD_GROUPS_SUCCESS = 'app/patchworks/LOAD_GROUPS_SUCCESS';
export var LOAD_GROUPS_FAILURE = 'app/patchworks/LOAD_GROUPS_FAILURE';
export var LOAD_ICONS_REQUEST = 'app/ViewBuilder/LOAD_ICONS_REQUEST';
export var LOAD_ICONS_SUCCESS = 'app/ViewBuilder/LOAD_ICONS_SUCCESS';
export var LOAD_ICONS_FAILURE = 'app/ViewBuilder/LOAD_ICONS_FAILURE';
export var LOAD_FILES_REQUEST = 'app/ViewBuilder/LOAD_FILES_REQUEST';
export var LOAD_FILES_SUCCESS = 'app/ViewBuilder/LOAD_FILES_SUCCESS';
export var LOAD_FILES_FAILURE = 'app/ViewBuilder/LOAD_FILES_FAILURE';
export var LOAD_DATASET_ROWS_REQUEST = 'app/patchworks/LOAD_DATASET_ROWS_REQUEST';
export var LOAD_DATASET_ROWS_SUCCESS = 'app/patchworks/LOAD_DATASET_ROWS_SUCCESS';
export var LOAD_DATASET_ROWS_FAILURE = 'app/patchworks/LOAD_DATASET_ROWS_FAILURE';
export var SET_LOADING_STATE = 'app/StructureBuilder/SET_LOADING_STATE';
export var UPDATE_CANVAS_OFFSET = 'app/StructureBuilder/UPDATE_CANVAS_OFFSET';
export var LOAD_INTEGRATION_REQUEST = 'app/patchworks/LOAD_INTEGRATION_REQUEST';
export var LOAD_INTEGRATION_SUCCESS = 'app/patchworks/LOAD_INTEGRATION_SUCCESS';
export var LOAD_INTEGRATION_FAILURE = 'app/patchworks/LOAD_INTEGRATION_FAILURE';
export var LOAD_METHODS_REQUEST = 'app/patchworks/LOAD_METHODS_REQUEST';
export var LOAD_METHODS_SUCCESS = 'app/patchworks/LOAD_METHODS_SUCCESS';
export var LOAD_METHODS_FAILURE = 'app/patchworks/LOAD_METHODS_FAILURE';
export var SET_VIEW_DEFAULT_STATE = 'app/StructureBuilder/SET_VIEW_DEFAULT_STATE';
export var SELECT_GROUP = 'app/StructureBuilder/SELECT_GROUP';
export var SELECT_GROUP_CHANGING = 'app/StructureBuilder/SELECT_GROUP_CHANGING';
export var dateFunctions = [
    { value: 'add', label: 'Add' },
    { value: 'subtract', label: 'Subtract' },
    { value: 'endOf', label: 'End of' },
    { value: 'startOf', label: 'Start of' },
    { value: 'set', label: 'Set' },
];
export var precisionsList = [
    { value: 'y', label: 'Years' },
    { value: 'Q', label: 'Quarters' },
    { value: 'M', label: 'Months' },
    { value: 'w', label: 'Weeks' },
    { value: 'd', label: 'Days' },
    { value: 'h', label: 'Hours' },
    { value: 'm', label: 'Minutes' },
];
export var setPrecisionsList = [
    { value: 'year', label: 'Years' },
    { value: 'month', label: 'Months' },
    { value: 'date', label: 'Days' },
    { value: 'hour', label: 'Hours' },
    { value: 'minute', label: 'Minutes' },
];
export var isDateFunction = [
    { value: 'isBefore', label: 'Is Before' },
    { value: 'isSame', label: 'Is Same' },
    { value: 'isAfter', label: 'Is After' },
    { value: 'isSameOrBefore', label: 'Is Same or Before' },
    { value: 'isSameOrAfter', label: 'Is Same or After' },
    { value: 'isBetween', label: 'Is Between' },
    { value: 'isDST', label: 'Is Dayight Saving Time' },
    { value: 'isLeapYear', label: 'Is Leap Year' },
    { value: 'isDate', label: 'Is Date' },
];
export var getDateUnitFunction = [
    { value: 'get', label: 'Get Date Unit' },
    { value: 'diff', label: 'Get Difference' },
];
export var COPY_LOGIC_REQUEST = 'app/patchworks/COPY_LOGIC_REQUEST';
export var COPY_LOGIC_SUCCESS = 'app/patchworks/COPY_LOGIC_SUCCESS';
export var COPY_LOGIC_FAILURE = 'app/patchworks/COPY_LOGIC_FAILURE';
export var COPY_LOGIC_GROUP_REQUEST = 'app/patchworks/COPY_LOGIC_GROUP_REQUEST';
export var COPY_LOGIC_GROUP_SUCCESS = 'app/patchworks/COPY_LOGIC_GROUP_SUCCESS';
export var COPY_LOGIC_GROUP_FAILURE = 'app/patchworks/COPY_LOGIC_GROUP_FAILURE';
export var CREATE_VIEW_REQUEST = 'app/patchworks/CREATE_VIEW_REQUEST';
export var CREATE_VIEW_SUCCESS = 'app/patchworks/CREATE_VIEW_SUCCESS';
export var CREATE_VIEW_FAILURE = 'app/patchworks/CREATE_VIEW_FAILURE';
export var CREATE_VIEW_EVENT_REQUEST = 'app/patchworks/CREATE_VIEW_EVENT_REQUEST';
export var CREATE_VIEW_EVENT_SUCCESS = 'app/patchworks/CREATE_VIEW_EVENT_SUCCESS';
export var CREATE_VIEW_EVENT_FAILURE = 'app/patchworks/CREATE_VIEW_EVENT_FAILURE';
export var CHANGE_VIEW_NAME_REQUEST = 'app/patchworks/CHANGE_VIEW_NAME_REQUEST';
export var CHANGE_VIEW_NAME_SUCCESS = 'app/patchworks/CHANGE_VIEW_NAME_SUCCESS';
export var CHANGE_VIEW_NAME_FAILURE = 'app/patchworks/CHANGE_VIEW_NAME_FAILURE';
export var UPDATE_PATCH_COORDS_REQUEST = 'app/patchworks/UPDATE_PATCH_COORDS_REQUEST';
export var UPDATE_PATCH_COORDS_SUCCESS = 'app/patchworks/UPDATE_PATCH_COORDS_SUCCESS';
export var UPDATE_PATCH_COORDS_FAILURE = 'app/patchworks/UPDATE_PATCH_COORDS_FAILURE';
export var SET_GLOBAL_STYLES_REQUEST = 'app/patchworks/SET_GLOBAL_STYLES_REQUEST';
export var SET_GLOBAL_STYLES_SUCCESS = 'app/patchworks/SET_GLOBAL_STYLES_SUCCESS';
export var SET_GLOBAL_STYLES_FAILURE = 'app/patchworks/SET_GLOBAL_STYLES_FAILURE';
